import { COLORS } from 'constants/colors';
import { ONE_GROVE_MAP_ID } from 'constants/oneGrove';
import { FREE_FEE_TABLE_ROWS } from 'constants/parking';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useMachineStore from 'stores/machine';
import styles from './FreeParkingFeeTableForSellingFacility.module.scss';

export default function FreeParkingFeeTableForSellingFacility() {
  const { t } = useTranslation();
  const { machine } = useMachineStore();

  const isOneGroveMachine = useMemo(() => {
    if (!machine) {
      return false;
    }

    return machine.map.id === ONE_GROVE_MAP_ID;
  }, [machine]);

  const descriptionClassName = useMemo(() => {
    return isOneGroveMachine ? styles.description_one_grove : styles.description;
  }, [isOneGroveMachine])

  return (
    <div className={styles.FreeParkingFeeTable}>
      <div className={styles.fee_title}>
        <div className={styles.left_bar} />
        <div className={styles.title_text}>{t('parking.freeParkingFeeTable.parkingFeeInformation')}</div>
      </div>

      <div className={styles.fee_table_container}>
        <div className={styles.fee_table}>
          {FREE_FEE_TABLE_ROWS.map((row, index) => {
            return (
              <div
                key={index}
                style={{
                  borderBottomColor: index === FREE_FEE_TABLE_ROWS.length - 1 ? COLORS.GRAY_44 : COLORS.GRAY_CC,
                }}
                className={styles.table_row}
              >
                <div className={styles.table_range}>
                  {t(`parking.freeParkingFeeTable.range`, { purchase: row.purchase })}
                </div>
                <div className={styles.table_content}>
                  <div>{t(`parking.freeParkingFeeTable.content`, { hour: row.hour })}</div>
                </div>
                <div className={styles.table_content}>
                  <div>-</div>
                </div>
              </div>
            );
          })}
        </div>

        <div className={styles.description_wrapper}>
          <div className={descriptionClassName}>※ {t('parking.freeParkingFeeTable.description1')}</div>
          <div className={descriptionClassName}>※ {t('parking.freeParkingFeeTable.description2')}</div>
          {isOneGroveMachine && <div className={descriptionClassName}>※ {t('parking.freeParkingFeeTable.onegroveDescription')}</div>}
        </div>
      </div>
    </div>
  );
}
